module.exports = __webpack_public_path__ + "static/img/mycompass_loginbkg_mnt4.504bd80.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mycompass_loginbkg_mnt4.jpg
// module id = GEUQ
// module chunks = 0